import { render, staticRenderFns } from "./MyVirtualAccount.vue?vue&type=template&id=6a35c47f&scoped=true&"
import script from "./MyVirtualAccount.vue?vue&type=script&lang=js&"
export * from "./MyVirtualAccount.vue?vue&type=script&lang=js&"
import style0 from "./MyVirtualAccount.vue?vue&type=style&index=0&id=6a35c47f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a35c47f",
  null
  
)

export default component.exports